import { decodeJwtPayload, loadSession } from './state';

function uniq(arr) {
  return Array.from(new Set(arr.filter(Boolean)));
}

function toStringArray(v) {
  if (Array.isArray(v)) return v.map((x) => String(x)).filter(Boolean);
  if (typeof v === 'string') return v.split(',').map((s) => s.trim()).filter(Boolean);
  return [];
}

export function extractRoles(session) {
  const s = session || loadSession();
  const user = s?.user || (s?.tokens?.idToken ? decodeJwtPayload(String(s.tokens.idToken)) : null);
  return uniq(toStringArray(user?.roles || user?.role || user?.['chamii:roles']));
}

export function extractGroups(session) {
  const s = session || loadSession();
  const user = s?.user || (s?.tokens?.idToken ? decodeJwtPayload(String(s.tokens.idToken)) : null);
  return uniq(toStringArray(user?.groups || user?.group || user?.['chamii:groups']));
}

